import React from 'react';
import tracking from '@g4/g4-analytics';

import { getHotelOrderDetails } from '../Hotels/hotelsPageAnalytics';

const TrackPayment = ({ children, data }) => {
  React.useEffect(() => {
    if (data.hotelOrder) {
      const { confirmationNumber } = data.hotelOrder;

      const hotelItem = data.hotelOrder.items.find(i => i.type === 'HOTEL');

      const purchaseItems = {
        eventName: 'purchase',
        value: hotelItem.price.total,
        coupon: '',
        currency: 'USD',
        transactionId: confirmationNumber,
        affiliation: 'WWW-HLO',
        shipping: '',
        tax: hotelItem.price.taxesAndFees,
        quantity: data.hotelOrder.items.length,
        savedTravelerCompletedBooking: 'No',
        products: [getHotelOrderDetails(hotelItem)],
      };

      window.localStorage.removeItem('cachedAnalyticsData');
      tracking.purchase(purchaseItems);
    }
  }, [data.hotelOrder]);

  return children;
};

export default TrackPayment;
